const getRestaurantIdFromUrl = () => {
    const currentUrl = window.location.href;
    const match = currentUrl.match(/\/restaurant\/(\d+)/);
    return match ? parseInt(match[1]) : null;
};

export default  getRestaurantIdFromUrl